import { z, ZodType } from "zod";
import { getMaterial } from "./database_helpers";
import { DBMaterialType } from "../database_types";

export const SavedFormDataKey = "SavedFormDataKey";
export type SavedFormData = {
    name: string;
    email: string;
    address: string;
    postalCode: string;
    city: string;
    nip: string;
    summary: string;
}

export const SavedProductDataKey = "SavedProducts";
export type SavedProductData = {
    // userSaveId: string; // support custom names some day

    productName: string;
    amount: number,
    sheets: SavedSheetData[]
}

export type SavedSheetData = {
    itemName: string;
    itemComment: string;
    materialCode: string;
    length: number;
    width: number;
    useGrain: boolean;
    amount: number;
    edgeLeft: EdgeData;
    edgeRight: EdgeData;
    edgeUp: EdgeData;
    edgeDown: EdgeData;
}

export const SavedOrderDataKey = "SavedOrderKey"; 

export type EdgeData = {
    // use: boolean;
    edgeCode: string;
    // useOverrideMaterialCode: boolean; // not used
    // overrideMaterialCode: string; // not used
}
export type SheetData = {
    itemName: string;
    itemComment: string;
    materialCode: string;
    length: number;
    width: number;
    useGrain: boolean;
    amount: number;
    edgeLeft: EdgeData;
    edgeRight: EdgeData;
    edgeUp: EdgeData;
    edgeDown: EdgeData;
}
export type ProductData = {
    productName: string;
    amount: number,
    sheets: SheetData[]
}
export type FormData = {
    name: string;
    email: string;
    address: string;
    postalCode: string;
    city: string;
    nip: string;
    summary: string;

    // savedProductSelection: string;

    products: ProductData[];
} // formatki

export function getValidationSchema(materialsDB: DBMaterialType[]) {

    const FormSchemaEdge: ZodType<EdgeData> = z.object({
        // use: z.boolean(),
        edgeCode: z.string(),
        // useOverrideMaterialCode: z.boolean(),
        // overrideMaterialCode: z.string(),

    });
    const FormSchemaSheet: ZodType<SheetData> = z.object({
        itemName: z.string(),
        itemComment: z.string(),
        materialCode: z.string().superRefine((schema, ctx) => {
            if (!materialsDB.some((mat) => mat?.code === schema)) {
                ctx.addIssue({ path: ["materialCode"], code: z.ZodIssueCode.custom, message: `Materiał nie jest dostępny w bazie, skontaktuj się z biurem.` });
            }
        }),
        // length: z.number().int().positive().min(85, '<p>Ta formatka jest za krótka (min 85), patrz: <a href="./tutorial" target="_blank">Problemy</a><p>'),
        // width: z.number().int().positive().min(85, '<p>Ta formatka jest za krótka (min 85), patrz: <a href="./tutorial" target="_blank">Problemy</a><p>'),
        length: z.number().int().positive().min(85, '<p>Ta formatka jest za krótka (min 85)<p>'),
        width: z.number().int().positive().min(85, '<p>Ta formatka jest za krótka (min 85)<p>'),
        useGrain: z.boolean(),
        amount: z.number().int().positive().min(0),
        // grain: z.string(), // should be literal
        edgeLeft: FormSchemaEdge,
        edgeRight: FormSchemaEdge,
        edgeUp: FormSchemaEdge,
        edgeDown: FormSchemaEdge,
    }).superRefine((schema, ctx) => {
        const material = getMaterial(materialsDB, schema?.materialCode);
        if (!material) { return; }
        if (material.sheets.every((_sheet) => schema?.length + 30 > _sheet?.length)) {
            ctx.addIssue({
                path: ["length"],
                code: z.ZodIssueCode.custom,
                message: `Formatka za długa! Ten materiał występuje w akruszach (30mm margines): ${material.sheets.map((_sheet) => _sheet?.length + "x" + _sheet?.width + " ")}`,
            });
            return "errorr";
        }
        if (material.sheets.every((_sheet) => schema?.width + 30 > _sheet?.width)) {
            ctx.addIssue({
                path: ["width"],
                code: z.ZodIssueCode.custom,
                message: `Formatka za szeroka! Ten materiał występuje w akruszach (30mm margines): ${material.sheets.map((_sheet) => _sheet?.length + "x" + _sheet?.width + " ")}`,
            });
            return "errorr";
        }
        return false;
    });
    /*
            .superRefine((schema, ctx) => {
                const material = getMaterial(materialsDB, schema.materialCode);
                console.log(material)
                if (!material) { return; }
                if (material.sheets.every((_sheet) => schema?.length > _sheet?.length)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `Formatka za długa! Ten materiał występuje w akruszach: ${material.sheets.map((_sheet) => _sheet?.length + "x" + _sheet?.width)}`,
                    });
                    return true;
                }
            },
            )
            */

    const FormSchemaProduct: ZodType<ProductData> = z.object({
        productName: z.string(),
        amount: z.number().int().min(0),
        sheets: z.array(FormSchemaSheet)
    });

    const FormSchema: ZodType<FormData> = z.object({
        name: z.string().nonempty("To pole nie może być puste"),
        email: z.string().email(),
        address: z.string(),
        postalCode: z.string(),
        city: z.string(),
        nip: z.string(),
        summary: z.string(),
        // savedProductSelection: z.string(),
        products: z.array(FormSchemaProduct)
    })

    return FormSchema;

}